import React from "react";
import Text from "components/common/Text";
import Box from "components/common/Box";
import AMENITIES from "./Amenities";
import ChargingPoint from "./ChargingPoint";
import TypeofConnectors from "./TypeofConnectors";
import { makeStyles } from "@mui/styles";

const StationOverview = ({
  data,
  onDeleteClick,
  onEnableClick,
  handleStatusConfirmConnectorClick,
  handleChargingPointConfirmClick,
  enableDisable,
}) => {
  const classes = useStyles();

  return (
    <>
      <Box
        sx={{
          width: "100%",
          borderBottom: "1px solid #EBEBEB",
          margin: "20px 10px 10px 10px",
        }}
      >
        <Text
          variant="h"
          component="div"
          gutterBottom
          sx={{
            fontSize: "16px",
            color: "#707070",
            fontWeight: "500",
          }}
        >
          CHARGING POINTS
        </Text>
      </Box>
      <Box
        className={classes.station_Charging}
        sx={{ display: "flex", flexWrap: "wrap" }}
      >
        {data.chargingPoints?.length > 0 ? (
          <ChargingPoint
            props={data.chargingPoints}
            handleChargingPointConfirmClick={handleChargingPointConfirmClick}
            onEnableClick={onEnableClick}
            enableDisable={enableDisable}
          />
        ) : (
          <Box
            sx={{
              display: "flex",
              height: "100px",
              alignItems: "center",
              justifyContent: "center",
              width:'50%'
            }}
          >
            <Text
              sx={{
                fontSize: "14px",
                color: "#707070",
                fontWeight: "500",
              }}
            >
              charging points are details not found
            </Text>
          </Box>
        )}
      </Box>

      <Box
        sx={{
          width: "100%",
          borderBottom: "1px solid #EBEBEB",
          margin: "40px 10px 10px 10px",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
        }}
      >
        <Text
          variant="h"
          component="div"
          gutterBottom
          sx={{
            fontSize: "16px",
            color: "#707070",
            fontWeight: "500",
          }}
        >
          TYPE OF CONNECTORS
        </Text>
      </Box>
      <Box
        className={classes.station_Connector}
        sx={{ display: "flex", flexWrap: "wrap" }}
      >
      {data.connecters?.length>0 ?  <TypeofConnectors
          props={data.connecters}
          onDeleteClick={onDeleteClick}
          handleStatusConfirmConnectorClick={handleStatusConfirmConnectorClick}
          onEnableClick={onEnableClick}
        /> :
         <Box
            sx={{
              display: "flex",
              height: "100px",
              alignItems: "center",
              justifyContent: "center",
              width:'50%'
            }}
          >
            <Text
              sx={{
                fontSize: "14px",
                color: "#707070",
                fontWeight: "500",
              }}
            >
              connectors type are details not found
            </Text>
          </Box>}
      </Box>
      <Box
        sx={{
          width: "100%",
          borderBottom: "1px solid #EBEBEB",
          margin: "40px 10px 10px 10px",
        }}
      >
        <Text
          variant="h"
          component="div"
          gutterBottom
          sx={{
            fontSize: "16px",
            color: "#707070",
            fontWeight: "500",
          }}
        >
          AMENITIES
        </Text>
      </Box>
      <Box
        className={classes.station_amenities}
        sx={{ display: "flex", marginRight: "10px", flexWrap: "wrap" }}
      >
      {data.amenities?.length>0 ?  <AMENITIES props={data.amenities} /> :
        <Box
            sx={{
              display: "flex",
              height: "100px",
              alignItems: "center",
              justifyContent: "center",
              width:'50%'
            }}
          >
            <Text
              sx={{
                fontSize: "14px",
                color: "#707070",
                fontWeight: "500",
              }}
            >
              Amenities details not found
            </Text>
          </Box>}
      </Box>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  station_amenities: {
    ["@media (max-width:768px)"]: {
      display: "block",
    },
  },

  station_Connector: {
    ["@media (max-width:768px)"]: {
      display: "block",
    },
  },

  station_Charging: {
    ["@media (max-width:768px)"]: {
      display: "block",
    },
  },
}));

export default StationOverview;
